import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const RatesCtx = createContext(null);

export const RatesProvider = ({ children }) => {
  const [rates, setRates] = useState(null);
  const [settings, setSettings] = useState(null);
  const [gstOn, setGstOn] = useState(false);

  const load = useCallback(async () => {
    const [r, s] = await Promise.all([
      api.get("/rates/today").then((x) => x.data).catch(() => null),
      api.get("/settings").then((x) => x.data).catch(() => null),
    ]);
    setRates(r);
    setSettings(s);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <RatesCtx.Provider value={{ rates, settings, gstOn, setGstOn, refresh: load, setRates, setSettings }}>
      {children}
    </RatesCtx.Provider>
  );
};

export const useRates = () => useContext(RatesCtx);
